var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { getGlobalState, getPaymentServiceUrl } from '../../Utils/GlobalState';
/**
 * Fetch the current basket.
 *
 * @returns Basket
 */
export const fetchBasket = () => __awaiter(void 0, void 0, void 0, function* () {
    const applicationUrl = getGlobalState('application_url');
    const response = yield axios.get(`${applicationUrl}/api/basket`, { withCredentials: true });
    return response.data;
});
export const fetchUser = () => __awaiter(void 0, void 0, void 0, function* () {
    const applicationUrl = getGlobalState('application_url');
    const response = yield axios.get(`${applicationUrl}/api/user/details`, { withCredentials: true });
    return response.data;
});
export const fetchWaitingForPaymentBasket = (userId) => __awaiter(void 0, void 0, void 0, function* () {
    const paymentUrl = getPaymentServiceUrl();
    const response = yield axios.get(`${paymentUrl}/api/baskets?user=${userId}&status=waiting_for_payment`, { withCredentials: true });
    return response.data;
});
/**
 * Add an item to the basket.
 *
 * @param {string} product
 * @param {string} purchaseType
 * @param {?string} identifier
 */
export const addToBasket = (product, purchaseType, identifier = null) => __awaiter(void 0, void 0, void 0, function* () {
    const applicationUrl = getGlobalState('application_url');
    const user = getGlobalState('user');
    const payload = {
        product,
        purchase_type: purchaseType
    };
    if (identifier) {
        payload.identifier = identifier;
    }
    if ((user === null || user === void 0 ? void 0 : user.onboardingPartner) != null) {
        payload.partner = user.onboardingPartner.id;
    }
    yield axios.post(`${applicationUrl}/api/basket`, payload, { withCredentials: true });
});
/**
 * Add multiple items to the basket.
 *
 * @param {array} products
 * @param {string} purchaseType
 * @param {null|string} identifier
 *
 * @returns {Promise<void>}
 */
export const addMultipleToBasket = (products, purchaseType, identifier = null) => __awaiter(void 0, void 0, void 0, function* () {
    for (const product of products) {
        yield addToBasket(product, purchaseType, identifier);
    }
});
/**
 * Update purchase type for an item
 *
 * @param {int} itemId
 * @param {string} purchaseType
 */
export const updateItem = (itemId, purchaseType) => __awaiter(void 0, void 0, void 0, function* () {
    const applicationUrl = getGlobalState('application_url');
    yield axios.put(`${applicationUrl}/api/basket/${itemId}`, { purchase_type: purchaseType }, { withCredentials: true });
});
/**
 * Remove an item from the basket.
 */
export const removeItem = (itemId) => __awaiter(void 0, void 0, void 0, function* () {
    const applicationUrl = getGlobalState('application_url');
    yield axios.delete(`${applicationUrl}/api/basket/${itemId}`, { withCredentials: true });
});
export const redirectToPayment = (userId, basketId) => {
    const paymentUrl = getPaymentServiceUrl();
    const applicationFullUrl = getGlobalState('application_full_url');
    window.location.href = `${paymentUrl}/payment/start?user=${userId}&basket=${basketId}&success_url=${applicationFullUrl}/checkout-completed?basket=${basketId}&failure_url=${applicationFullUrl}/payment-failed`;
};
